import {ColorPicker, useColor} from "react-color-palette";
import "react-color-palette/lib/css/styles.css";
import React, {memo, useEffect, useState} from 'react';
import './index.scss';
import {useRPC} from "../../hooks/rpc";

export const ColorScreen = memo(function ColorScreen() {
    const [color, setColor] = useColor("hex", "#ffffff");
    const text = color.rgb;
    const [rpc] = useRPC();

    function valueChange() {
        if (color) {
            console.log(text);
            rpc.RGBColor(text.r + "-" + text.g + "-" + text.b);
        }
    }

    return (
        <div className="picker-container">
            <ColorPicker
                width={400}
                height={200}
                color={color}
                onChange={setColor}
                onChangeComplete={valueChange}
                hideHSV
                hideRGB
                hideHEX
                dark
                alpha
            />
        </div>
    )
});
export default ColorScreen;
